import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

if (typeof window !== "undefined") {
  // tslint:disable-next-line:no-var-requires
  const WebFontLoader = require("webfontloader");
  WebFontLoader.load({
    google: {
      families: [
        "Arimo:700",
        "PT Serif:400",
        "Source Sans Pro:400",
        "Source Sans Pro:700",
        "Source Sans Pro:ital@1"
      ]
    }
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
